<template>
  <div id="home" class="main-container">
    <loading-screen @disableScrollMenu="isScrolling = $event" />

    <div
      id="off-touch"
      class="orientation-landscape"
      v-bind:class="{mobile: isMobile && heightLessThanWidth === true && isMobileKeyboard === false && activeSection !== 8}"
    >
      <h2>Turn your device please.</h2>
    </div>

    <Menu
      v-bind:class="{off: this.offClickMenu}"
      :offClickMenu="this.offClickMenu"
      :disableScroll="this.disableScroll"
      :hamburgerColor="this.activeSectionMenuColor"
      :showChild="!activeSection == 8 || !isMobile || !heightLessThanWidth && isMobile"
      :title="sections[activeSectionTitle].title"
      :dot="sections[activeSectionTitle].dot"
      :textColor="sections[activeSectionTitle].textColor"
      :agency="sections[activeSectionTitle].agency"
      :client="sections[activeSectionTitle].client"
      :role="sections[activeSectionTitle].role"
      :url="sections[activeSectionTitle].url"
      :subtitle="sections[activeSectionTitle].subtitle"
      :specificationColor="sections[activeSectionTitle].specificationColor"
      @changeActiveSection="activeSection = $event"
      @disableScrollMenu="isScrolling = $event"
      @isBlackChange="isBlack = $event"
    />
    <a href title="intervi" aria-label="logo">
      <div
        class="main-container__logo"
        v-bind:class="{ white: isWhite & isBlack == false, black: isBlack }"
      >
        <transition appear mode="out-in" @appear="enterLogo" @enter="enterLogo" @leave="leaveLogo">
          <div v-show="!activeSection == 8 || !isMobile || !heightLessThanWidth && isMobile">
            <svg
              width="109px"
              height="19px"
              viewBox="0 0 109 19"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <polygon
                  id="path-1"
                  points="0 0.385902439 5.90810769 0.385902439 5.90810769 17.9477561 0 17.9477561"
                />
                <polygon
                  id="path-3"
                  points="0.000230769231 0.325714286 17.7233077 0.325714286 17.7233077 17.9491286 0.000230769231 17.9491286"
                />
                <polygon
                  id="path-5"
                  points="0.0345857143 0.335813953 17.8631571 0.335813953 17.8631571 18.9998674 0.0345857143 18.9998674"
                />
                <polygon
                  id="path-7"
                  points="0.35506875 0.03138 5.8695 0.03138 5.8695 5.91358 0.35506875 5.91358"
                />
              </defs>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-276.000000, -56.000000)">
                  <g id="Group-21" transform="translate(276.000000, 56.000000)">
                    <g id="Group-3">
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1" />
                      </mask>
                      <g id="Clip-2" />
                      <path
                        d="M5.90810769,0.859170732 L5.90810769,17.4744878 C5.90810769,17.7357073 5.68564615,17.9477561 5.41056923,17.9477561 L0.497492308,17.9477561 C0.222876923,17.9477561 -4.61538462e-05,17.7357073 -4.61538462e-05,17.4744878 L-4.61538462e-05,0.859170732 C-4.61538462e-05,0.597512195 0.222876923,0.385902439 0.497492308,0.385902439 L5.41056923,0.385902439 C5.68564615,0.385902439 5.90810769,0.597512195 5.90810769,0.859170732"
                        id="Fill-1"
                        fill="#000000"
                        mask="url(#mask-2)"
                      />
                    </g>
                    <g id="Group-6" transform="translate(9.000000, 0.000000)">
                      <mask id="mask-4" fill="white">
                        <use xlink:href="#path-3" />
                      </mask>
                      <g id="Clip-5" />
                      <path
                        d="M17.7233077,7.42298571 L17.7233077,17.4867 C17.7233077,17.7421286 17.5008462,17.9491286 17.2257692,17.9491286 L12.6823846,17.9491286 C12.4073077,17.9491286 12.1848462,17.7421286 12.1848462,17.4867 L12.1848462,8.17727143 C12.1848462,6.05112857 10.7448462,5.05684286 8.97253846,5.05684286 C6.94176923,5.05684286 5.53869231,6.15398571 5.53869231,8.5887 L5.53869231,17.4867 C5.53869231,17.7421286 5.31576923,17.9491286 5.04069231,17.9491286 L0.497769231,17.9491286 C0.222692308,17.9491286 0.000230769231,17.7421286 0.000230769231,17.4867 L0.000230769231,1.26741429 C0.000230769231,1.01198571 0.222692308,0.805414286 0.497769231,0.805414286 L5.04069231,0.805414286 C5.31576923,0.805414286 5.53869231,1.01198571 5.53869231,1.26741429 C5.53869231,1.65227143 6.02146154,1.87512857 6.34130769,1.62955714 C7.39961538,0.8187 8.93192308,0.325414286 10.8186923,0.325414286 C14.5479231,0.325414286 17.7233077,2.79398571 17.7233077,7.42298571"
                        id="Fill-4"
                        fill="#000000"
                        mask="url(#mask-4)"
                      />
                    </g>
                    <path
                      d="M36.9355129,1 L38.7299651,5.47259445 C38.8571375,5.79056622 38.6420179,6.14515833 38.3211967,6.14515833 L36.0428287,6.14515833 C35.7967419,6.14515833 35.5977253,6.36086109 35.5977253,6.62702846 L35.5977253,12.4693131 C35.5977253,13.892594 36.6477234,14.1199081 38.5367291,14.0314834 C38.7885965,14.0194255 39,14.2395941 39,14.5120137 L39,18.4250315 C39,18.6737819 38.8216283,18.8845721 38.5924703,18.906455 C32.4460794,19.487468 30.6429563,17.3643813 30.6429563,12.4693131 L30.6429563,6.62702846 C30.6429563,6.36086109 30.4435269,6.14515833 30.1978529,6.14515833 L28.4455163,6.14515833 C28.1994295,6.14515833 28,5.92990216 28,5.66373478 L28,1"
                      id="Fill-7"
                      fill="#000000"
                    />
                    <g id="Group-11" transform="translate(41.000000, 0.000000)">
                      <mask id="mask-6" fill="white">
                        <use xlink:href="#path-5" />
                      </mask>
                      <g id="Clip-10" />
                      <path
                        d="M12.0975857,7.82963488 C12.4391571,7.82963488 12.6564429,7.46244884 12.5137286,7.1421 C11.8327286,5.61105349 10.4763,5.0375186 9.1203,5.0375186 C7.43001429,5.0375186 6.22744286,5.77675116 5.62272857,7.14254186 C5.48087143,7.4628907 5.69687143,7.82963488 6.03844286,7.82963488 L12.0975857,7.82963488 Z M9.6003,14.2635651 C10.8615857,14.2635651 11.9574429,13.808007 12.6641571,13.1527279 C12.8098714,13.0175186 13.0241571,12.9985186 13.1943,13.0997047 L16.5487286,15.0880767 C16.7908714,15.2312395 16.8615857,15.5674953 16.6850143,15.7910767 C15.0101571,17.9106814 12.5878714,18.9998674 9.53172857,18.9998674 C3.66844286,18.9998674 0.0345857143,14.935193 0.0345857143,9.66777442 C0.0345857143,4.40035581 3.73701429,0.335681395 9.15458571,0.335681395 C14.1598714,0.335681395 17.8631571,4.3301 17.8631571,9.66777442 C17.8631571,10.2682628 17.8185857,10.8448907 17.7290143,11.3985419 C17.6921571,11.6256581 17.4954429,11.7887047 17.2717286,11.7887047 L6.22272857,11.7887047 C5.86187143,11.7887047 5.63558571,12.2000767 5.8263,12.5151233 C6.60201429,13.798286 7.98844286,14.2635651 9.6003,14.2635651 Z"
                        id="Fill-9"
                        fill="#000000"
                        mask="url(#mask-6)"
                      />
                    </g>
                    <path
                      d="M71.5127354,1.43557822 L72.9775077,6.07079646 C73.078264,6.39163042 72.827045,6.70436478 72.4925342,6.69176541 C70.290226,6.60671966 67.3736678,7.65651717 67.3736678,10.8639568 L67.3736678,18.5149243 C67.3736678,18.7831108 67.1573777,19 66.8909333,19 L62.4827345,19 C62.2158423,19 62,18.7831108 62,18.5149243 L62,1.48507575 C62,1.21733913 62.2158423,1 62.4827345,1 L66.8909333,1 C67.1573777,1 67.3736678,1.21733913 67.3736678,1.48507575 L67.3736678,2.01379931 C67.3736678,2.47232638 67.9602932,2.69101545 68.2352459,2.32518374 C68.8711299,1.47832608 69.7416641,1.14579271 71.0434351,1.09719514 C71.2570384,1.08909555 71.4478036,1.23083846 71.5127354,1.43557822"
                      id="Fill-12"
                      fill="#000000"
                    />
                    <path
                      d="M91.9711609,1.65336733 L86.0071913,18.6832158 C85.9403239,18.8735563 85.7686836,19 85.5761738,19 L80.4235562,19 C80.2318982,19 80.0594061,18.8735563 79.9929647,18.6832158 L74.028995,1.65336733 C73.9178334,1.33658317 74.1401566,1 74.4595866,1 L79.1236894,1 C79.3221618,1 79.4980612,1.13454327 79.5598177,1.33388331 L82.5637367,11.0070496 C82.7017304,11.4520774 83.2979996,11.4520774 83.4364192,11.0070496 L86.4403382,1.33388331 C86.5016688,1.13454327 86.6775682,1 86.8764666,1 L91.5401435,1 C91.8599993,1 92.0818966,1.33658317 91.9711609,1.65336733"
                      id="Fill-14"
                      fill="#000000"
                    />
                    <path
                      d="M95.4491667,1 L99.5508333,1 C99.79875,1 100,1.21688916 100,1.48507575 L100,18.5149243 C100,18.7831108 99.79875,19 99.5508333,19 L95.4491667,19 C95.2008333,19 95,18.7831108 95,18.5149243 L95,1.48507575 C95,1.21688916 95.2008333,1 95.4491667,1"
                      id="Fill-16"
                      fill="#000000"
                    />
                    <g id="Group-20" transform="translate(103.000000, 13.000000)">
                      <mask id="mask-8" fill="white">
                        <use xlink:href="#path-7" />
                      </mask>
                      <g id="Clip-19" />
                      <path
                        d="M1.7659125,5.32108 L0.9105375,4.40868 C0.1699125,3.61868 0.1699125,2.32628 0.9105375,1.53588 L1.7659125,0.62388 C2.5065375,-0.16612 3.7181625,-0.16612 4.4587875,0.62388 L5.3141625,1.53588 C6.0547875,2.32628 6.0547875,3.61868 5.3141625,4.40868 L4.4587875,5.32108 C3.7181625,6.11108 2.5065375,6.11108 1.7659125,5.32108"
                        id="Fill-18"
                        fill="#000000"
                        mask="url(#mask-8)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </transition>
      </div>
    </a>

    <FloatingCaseStudy
      :caseColor="sections[activeSectionTitle].caseColor"
      :caseText="sections[activeSectionTitle].caseText"
      :showChild="showChild"
    ></FloatingCaseStudy>
    <FloatingSocials
      :floatingColors="sections[activeSectionTitle].floatingColors"
      :hoverColor="sections[activeSectionTitle].dot"
    />
    <FloatingText :floatingColors="sections[activeSectionTitle].floatingColors" />

    <transition-group
      appear
      :css="false"
      @appear="sectionEnter"
      @enter="sectionEnter"
      @afterEnter="afterSectionEnter"
      @leave="sectionLeave"
    >
      <component1
        key="0"
        v-show="activeSection == 0"
        :showChild="showChild"
        :activeSection="activeSection"
        :blobMain="blobMain"
        :blobMobile="blobMobile"
        @ChangeActiveSection="activeSection = $event"
      ></component1>

      <component-mercedes key="1" v-show="activeSection == 1" :showChild="showChild"></component-mercedes>

      <component-pizza-box key="2" v-show="activeSection == 2" :showChild="showChild"></component-pizza-box>

      <component-nykart key="3" v-show="activeSection == 3" :showChild="showChild"></component-nykart>

      <component-social-monster
        key="4"
        v-show="activeSection == 4"
        :showChild="showChild"
        :activeSection="activeSection"
      ></component-social-monster>

      <component-brilliant-mind
        key="5"
        v-show="activeSection == 5"
        :showChild="showChild"
        :activeSection="activeSection"
      ></component-brilliant-mind>

      <component-janczaki key="6" v-show="activeSection == 6" :showChild="showChild"></component-janczaki>

      <component-matthias key="7" v-show="activeSection == 7" :showChild="showChild"></component-matthias>

      <component-social-monster-new key="8" v-show="activeSection == 8" :showChild="showChild"></component-social-monster-new>

      <component-streetwear key="9" v-show="activeSection == 9" :showChild="showChild"></component-streetwear>

      <component-about
        key="10"
        v-show="activeSection == 10"
        :showChild="showChild"
        :activeSection="activeSection"
        :activeSectionSubpage="activeSectionSubpage"
      ></component-about>

      <component-team
        key="11"
        v-show="activeSection == 11"
        :showChild="showChild"
        v-bind:showTeam="showTeam"
        :sections="sections"
        :activeSection="activeSection"
      ></component-team>

      <component-contact
        key="12"
        v-show="activeSection == 12"
        :showChild="showChild"
        :isMobile="isMobile"
      ></component-contact>
    </transition-group>

    <SectionTitle
      v-if="!activeSection == 13 || !isMobile || !heightLessThanWidth && isMobile"
      :showChild="showChild"
      :title="sections[activeSectionTitle].title"
      :name="sections[activeSectionTitle].name"
      :dot="sections[activeSectionTitle].dot"
      :textColor="sections[activeSectionTitle].textColor"
      :agency="sections[activeSectionTitle].agency"
      :client="sections[activeSectionTitle].client"
      :role="sections[activeSectionTitle].role"
      :url="sections[activeSectionTitle].url"
      :sectionType="sections[activeSectionTitle].sectionType"
      :subtitle="sections[activeSectionTitle].subtitle"
      :scrollIcon="sections[activeSectionTitle].scrollIcon"
      :specificationColor="sections[activeSectionTitle].specificationColor"
      :projectPage="sections[activeSectionTitle].projectPage"
      :projectLogo="sections[activeSectionTitle].projectLogo"
    ></SectionTitle>

    <home-page-sections-nav
      :sections="sections"
      :showChild="showChild"
      :activeSection="activeSection"
      :isWhite="isWhite"
      @changeActiveSection="activeSection = $event"
    ></home-page-sections-nav>
  </div>
</template>

<script>
import Component1 from "@/components/inner-components/Component1";
import ComponentSocialMonster from "@/components/inner-components/ComponentSocialMonster";
import ComponentCunaSportwear from "@/components/inner-components/ComponentCunaSportwear";
import ComponentBrilliantMind from "@/components/inner-components/ComponentBrilliantMind";
import ComponentMercedes from "@/components/inner-components/ComponentMercedes";
import ComponentPizzaBox from "@/components/inner-components/ComponentPizzaBox";
import ComponentNykart from "@/components/inner-components/ComponentNykart";
import ComponentAbout from "@/components/inner-components/ComponentAbout";
import ComponentTeam from "@/components/inner-components/ComponentTeam";
import ComponentContact from "@/components/inner-components/ComponentContact";
import ComponentJanczaki from "@/components/inner-components/ComponentJanczaki";
import ComponentMatthias from "@/components/inner-components/ComponentMatthias";
import ComponentStreetwear from "@/components/inner-components/ComponentStreetwear";
import ComponentSocialMonsterNew from "@/components/inner-components/ComponentSocialMonsterNew";

import SectionTitle from "@/components/small-components/SectionTitle";
import Menu from "@/components/small-components/Menu";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingText from "@/components/small-components/FloatingText";
import FloatingCaseStudy from "@/components/small-components/FloatingCaseStudy";
import FloatingContact from "@/components/small-components/FloatingContact";
import HomePageSectionsNav from "@/components/small-components/HomePageSectionsNav";
import LoadingScreen from "@/components/inner-components/LoadingScreen";

import MobileDetect from "mobile-detect";

export default {
  name: "HomePage",
  data() {
    return {
      isWhite: "",
      isBlack: false,
      prevBg: "",
      isScrolling: "",
      downScroll: true,
      upScroll: false,
      offClickMenu: false,
      activeSection: 0,
      activeSectionTitle: 0,
      activeSectionMenuColor: "",
      showChild: true,
      showTeam: false,
      checkMenu: false,
      screenOrientation: "",
      isMobileKeyboard: false,
      isMobile: "",
      window: {
        width: 0,
        height: 0
      },
      heightLessThanWidth: false,
      activeSectionSubpage: false,
      blobMobile: "",
      blobMain: "",
      sections: [
        {
          name: "Intro",
          absoluteIndex: 0,
          relativeIndex: 0,
          sectionType: "intro",
          subtitle: "LET’S WORK TOGETHER",
          logoWhite: false,
          navigation: false,
          title: [
            "Your amazing idea.",
            'Our tailored creation<span class="coloredDot">.</span>'
          ],
          logoWhite: false,
          floatingColors: "gray",
          scrollIcon: `<span class="mouse">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <g>
                <g>
                    <path d="M256,140.15c-9.364,0-16.954,7.59-16.954,16.954v59.338c0,9.364,7.59,16.954,16.954,16.954
                        c9.364,0,16.954-7.59,16.954-16.954v-59.338C272.954,147.74,265.364,140.15,256,140.15z"/>
                </g>
            </g>
            </svg>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <g>
                <g>
                    <path d="M256,0C156.595,0,75.726,82.14,75.726,183.099v145.807C75.726,429.865,156.595,512,256,512
                        c99.399,0,180.274-81.886,180.274-182.534V183.099C436.274,82.14,355.399,0,256,0z M402.366,329.466
                        c0,81.954-65.656,148.627-146.366,148.627c-80.705,0-146.366-66.927-146.366-149.192V183.099
                        c0-82.265,65.661-149.192,146.366-149.192c80.711,0,146.366,66.927,146.366,149.192V329.466z"/>
                </g>
            </g>
            </svg>
          </span><span>Scroll down</span>`
        },
        {
          name: "Mercedes",
          navigation: true,
          absoluteIndex: 1,
          relativeIndex: 0,
          // absoluteIndex: 3,
          // relativeIndex: 2,
          sectionType: "caseStudy",
          bgColor: ".bg.bg_dark-gray",
          navColor: "#fff",
          activeNavDotColor: "#00e6ff",
          title: ['Mercedes Me<span class="coloredDot">.</span>', "Concept"],
          dot: "bright-sky-blue2",
          textColor: "white",
          caseText: "Case study.",
          specificationColor: "gray-two",
          caseColor: "gray-two",
          agency: "Intervi",
          client: "Marcin Rumierz",
          role: "UI/UX/Branding",
          projectPage: "project-mercedes",
          hamburgerColor: "white",
          logoWhite: true,
          // projectLogo: "project-logos/logo.png",
          floatingColors: "light-gray"
        },
        {
          name: "PizzaBox",
          navigation: true,
          absoluteIndex: 2,
          relativeIndex: 1,
          // absoluteIndex: 5,
          // relativeIndex: 4,
          sectionType: "caseStudy",
          bgColor: "#e61a1a",
          navColor: "#fff",
          activeNavDotColor: "#00aaff",
          title: [
            "We love pizza",
            "And pizza",
            'loves us back<span class="coloredDot">.</span>'
          ],
          dot: "dominos-blue",
          textColor: "white",
          specificationColor: "black",
          caseColor: "white",
          caseText: "Case study.",
          agency: "Intervi",
          client: "Pizza Box",
          role: "UI/UX/Branding",
          // url: "http://pizzabox.co",
          projectPage: "project-pizzabox",
          hamburgerColor: "white",
          logoWhite: true,
          floatingColors: "white",
          projectLogo: "project-logos/pizzabox_logo_sygnet.svg"
        },
        {
          name: "Nykart",
          navigation: true,
          absoluteIndex: 3,
          relativeIndex: 2,
          sectionType: "caseStudy",
          bgColor: "#c2963e",
          navColor: "#fff",
          activeNavDotColor: "#2b2b2b",
          title: [
            "New furniture",
            'styles<span class="coloredDot">.</span>'
          ],
          dot: "black",
          textColor: "white",
          specificationColor: "black",
          caseColor: "black",
          caseText: "Case study.",
          agency: "Intervi",
          client: "Nykart",
          role: "UI/UX/Branding",
          url: "http://nykart.pl",
          projectPage: "project-nykart",
          hamburgerColor: "",
          logoWhite: false,
          floatingColors: "white",
          projectLogo: "project-logos/page-1.svg"
        },
        {
          name: "Social Monster",
          navigation: true,
          absoluteIndex: 4,
          relativeIndex: 3,
          sectionType: "caseStudy",
          title: [
            "Custom drawings",
            "that promote",
            'your brand<span class="coloredDot">.</span>'
          ],
          dot: "cyan",
          textColor: "white",
          caseColor: "slate",
          navColor: "#fff",
          activeNavDotColor: "#5edde6",
          caseText: "Case study.",
          agency: "Intervi",
          client: "Social Monster",
          role: "UI/UX/Branding",
          url: "http://socialmonster.pl",
          projectPage: "project-social",
          hamburgerColor: "white",
          logoWhite: true,
          floatingColors: "white",
          projectLogo: ""
        },
        {
          name: "Brilliant Mind",
          navigation: true,
          absoluteIndex: 5,
          relativeIndex: 4,
          sectionType: "caseStudy",
          bgColor: "#7cb8c7t",
          navColor: "#fff",
          activeNavDotColor: "#f98c00",
          title: ["Brilliant", 'Minds<span class="coloredDot">.</span>'],
          dot: "orange",
          textColor: "white",
          specificationColor: "black",
          caseColor: "brown-grey",
          caseText: "Case study.",
          agency: "Intervi",
          client: "Brilliant Mind",
          role: "UI/UX/Branding",
          url: "http://brilliantmind.pl",
          projectPage: "project-brilliant-mind",
          hamburgerColor: "white",
          logoWhite: true,
          floatingColors: "white",
          projectLogo: "project-logos/bitmap@3x.png"
        },
        {
          name: "Janczaki",
          navigation: true,
          absoluteIndex: 6,
          relativeIndex: 5,
          sectionType: "caseStudy",
          bgColor: "#c2963e",
          navColor: "#fff",
          activeNavDotColor: "#2b2b2b",
          title: [
            "Brand heroes -",
            "win hearts,",
            "increase",
            'sales<span class="coloredDot">.</span>'
          ],
          dot: "yellow",
          textColor: "white",
          caseText: "Case study.",
          specificationColor: "black",
          caseColor: "white",
          agency: "Intervi",
          client: "Janczaki",
          role: "UI/UX/Branding",
          projectPage: "project-janczaki",
          hamburgerColor: "white",
          logoWhite: true,
          projectLogo: "project-logos/janczaki-logo.svg",
          floatingColors: "white"
        },
        {
          name: "Matthias",
          navigation: true,
          absoluteIndex: 7,
          relativeIndex: 6,
          sectionType: "caseStudy",
          bgColor: "#CFB595",
          navColor: "#fff",
          activeNavDotColor: "#2b2b2b",
          title: ["Food", "rebranding<span class='coloredDot'>.</span>"],
          dot: "matthias-red",
          textColor: "white",
          caseText: "Case study.",
          specificationColor: "black",
          caseColor: "white",
          agency: "Intervi",
          client: "Matthias",
          role: "UI/UX/Branding",
          projectPage: "project-matthias",
          hamburgerColor: "white",
          logoWhite: true,
          projectLogo: "project-logos/matthias-logo.svg",
          floatingColors: "white"
        },
        {
          name: "Social Monster New",
          navigation: true,
          absoluteIndex: 8,
          relativeIndex: 7,
          sectionType: "caseStudy",
          bgColor: "#46D0FF",
          navColor: "#fff",
          activeNavDotColor: "#2b2b2b",
          title: [
            "Social Monster",
            "Rebranding<span class='coloredDot'>.</span>"
          ],
          dot: "monster-pink",
          textColor: "white",
          caseText: "Case study.",
          specificationColor: "black",
          caseColor: "white",
          agency: "Intervi",
          client: "Social Monster",
          role: "UI/UX/Branding",
          projectPage: "project-social-monster-new",
          hamburgerColor: "white",
          logoWhite: true,
          // projectLogo: "project-logos/matthias-logo.svg",
          floatingColors: "black"
        },
        {
          name: "Streetwear",
          navigation: true,
          absoluteIndex: 9,
          relativeIndex: 8,
          sectionType: "caseStudy",
          bgColor: "#CFB595",
          navColor: "#fff",
          activeNavDotColor: "#2b2b2b",
          title: [
            "Luxury e-shop",
            "with hip-hop flair<span class='coloredDot'>.</span>"
          ],
          dot: "street-gold",
          textColor: "street-gray",
          caseText: "Case study.",
          specificationColor: "street-light-gray",
          caseColor: "white",
          agency: "Intervi",
          client: "Social Monster",
          role: "UI/UX/Branding",
          projectPage: "project-streetwear",
          hamburgerColor: "white",
          logoWhite: true,
          // projectLogo: "project-logos/matthias-logo.svg",
          floatingColors: "street-light-gray"
        },

        {
          name: "About",
          navigation: true,
          caseText: "About.",
          absoluteIndex: 10,
          relativeIndex: 0,
          sectionType: "about",
          bgColor: "#ffffff",
          navColor: "#d2d2d2",
          activeNavDotColor: "#000",
          logoWhite: false,
          floatingColors: "light-gray"
        },
        {
          name: "Team",
          navigation: true,
          caseText: "Team.",
          absoluteIndex: 11,
          relativeIndex: 1,
          sectionType: "about",
          bgColor: "#ffffff",
          navColor: "#d2d2d2",
          activeNavDotColor: "#2b2b2b",
          logoWhite: false
        },
        {
          name: "Contact",
          navigation: false,
          caseText: "Contact.",
          caseColor: "white",
          absoluteIndex: 12,
          relativeIndex: 0,
          sectionType: "contact",
          bgColor: "#0300e2",
          title: [
            "Let’s talk",
            "about your",
            '<span class="projectColored">project</span><span class="coloredDot">.</span>'
          ],
          dot: "white",
          textColor: "white",
          hamburgerColor: "white",
          logoWhite: true,
          floatingColors: "white",
          navColor: "transparent"
        }
      ]
    };
  },
  props: ["isScrollingLoader"],
  created() {
    // Important routing menu function
    this.routeTest();
    window.addEventListener("resize", this.scrollOffMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.scrollOffMobile);
  },
  methods: {
    detectOrientation: function() {
      window.addEventListener("orientationchange", function() {
        // Announce the new orientation number

        if (window.matchMedia("(orientation: portrait)").matches) {
          // you're in PORTRAIT mode
          this.screenOrientation = true;
        }
        if (window.matchMedia("(orientation: landscape)").matches) {
          // you're in LANDSCAPE mode
          this.screenOrientation = false;
        }
      });
    },

    detectMobileKeyboard: function() {
      document.getElementById("input-1").addEventListener("focus", myFunction);
      document.getElementById("input-1").addEventListener("blur", myFunction2);

      document.getElementById("input-2").addEventListener("focus", myFunction);
      document.getElementById("input-2").addEventListener("blur", myFunction2);

      document.getElementById("input-3").addEventListener("focus", myFunction);
      document.getElementById("input-3").addEventListener("blur", myFunction2);

      document.getElementById("input-4").addEventListener("focus", myFunction);
      document.getElementById("input-4").addEventListener("blur", myFunction2);

      var _this = this;
      function myFunction() {
        setTimeout(() => {
          _this.isMobileKeyboard = true;
        }, 401);
      }
      function myFunction2() {
        setTimeout(() => {
          _this.isMobileKeyboard = false;
        }, 400);
      }

      // window.addEventListener("focus", function() {
      //   // Announce the new orientation number

      //    if (window.matchMedia("(orientation: portrait)").matches) {
      //     // you're in PORTRAIT mode
      //       this.screenOrientation = true;
      //     }
      //     if (window.matchMedia("(orientation: landscape)").matches) {
      //       // you're in LANDSCAPE mode
      //       this.screenOrientation = false;
      //     }

      // });
    },

    detectionMobile: function() {
      var md = new MobileDetect(window.navigator.userAgent);
      var _this = this;
      if (
        md.mobile() !== null ||
        md.mobile() == "UnknownPhone" ||
        md.mobile() == "GenericPhone" ||
        md.mobile() == "iPhone" ||
        md.mobile() == "iPad" ||
        md.mobile() == "Tablet" ||
        md.mobile() == "Kindle" ||
        md.mobile() == "HTC" ||
        md.mobile() == "Samsung" ||
        md.mobile() == "BlackBerry" ||
        md.mobile() == "LG" ||
        md.mobile() == "NokiaLumia" ||
        md.mobile() == "NexusTablet" ||
        md.mobile() == "Xiaomi" ||
        md.mobile() == "Huawei"
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    scrollOffMobile: function() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      var myElement = document.getElementById("home");
      // Check device orientation & type - disable scroll/touch on horizontal mobile devices
      if (
        this.window.height <= this.window.width &&
        this.window.width <= 1023 &&
        this.isMobile == true
      ) {
        this.isScrolling = true;
      } else {
        this.isScrolling = false;
        var _this = this;
        //Add mouse wheel detection
        myElement.addEventListener("wheel", function(e) {
          e.preventDefault();
          if (e.deltaY < 0 && !_this.isScrolling) {
            _this.decreaseActiveSection();
          } else if (e.deltaY > 0 && !_this.isScrolling) {
            _this.increaseActiveSection();
          }
        });

        // Add touch gestures
        // var myElement = document.getElementById("home");
        var mc = new Hammer(myElement, { inputClass: Hammer.TouchInput });
        mc.get("pan").set({
          direction: Hammer.DIRECTION_ALL
        });

        mc.on("panup", function(ev) {
          if (!_this.isScrolling) {
            _this.increaseActiveSection();
          }
        });
        mc.on("pandown", function(ev) {
          if (!_this.isScrolling) {
            _this.decreaseActiveSection();
          }
        });
      }
    },
    innerHeight: function() {
      setTimeout(() => {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        this.heightLessThanWidth = this.window.height < this.window.width;

        // We listen to the resize event
        window.addEventListener("resize", () => {
          this.heightLessThanWidth = this.window.height < this.window.width;
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
      }, 500);
    },
    increaseActiveSection: function() {
      this.downScroll = false;
      this.upScroll = true;

      this.isScrolling = true;
      this.offClickMenu = true;
      this.activeSection >= this.sections.length - 1
        ? (this.activeSection = this.sections.length - 1)
        : this.activeSection++;

      setTimeout(() => {
        this.isScrolling = false;
        this.offClickMenu = false;
      }, 2000);
    },
    decreaseActiveSection: function() {
      this.downScroll = true;
      this.upScroll = false;

      this.isScrolling = true;
      this.offClickMenu = true;
      this.activeSection <= 0 ? (this.activeSection = 0) : this.activeSection--;

      setTimeout(() => {
        this.isScrolling = false;
        this.offClickMenu = false;
      }, 2000);
    },

    disableScroll: function() {
      this.isScrolling = true;
    },

    sectionEnter: function(el, done) {
      if (this.activeSection == 11) {
        this.showTeam = true;
      }
      TweenMax.fromTo(
        el,
        1.5,
        {
          transform: `translatey(${this.upScroll ? "100%" : "-100%"})`
        },
        {
          ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
          // ease: Power3.easeOut,
          transform: "translatey(0%)",
          onComplete: done
        }
      );
    },
    afterSectionEnter: function(el) {
      this.activeSectionMenuColor = this.sections[
        this.activeSectionTitle
      ].hamburgerColor;
      this.isWhite = this.sections[this.activeSectionTitle].logoWhite;
    },
    sectionLeave: function(el, done) {
      TweenMax.to(el, 1.5, {
        ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
        // ease: Power3.easeOut,
        transform: `translatey(${this.upScroll ? "-100%" : "100%"})`,
        onComplete: done
      });

      setTimeout(() => {
        this.activeSectionTitle = this.activeSection;
        this.showChild = true;
        this.activeSectionMenuColor = this.sections[
          this.activeSectionTitle
        ].hamburgerColor;
        this.isWhite = this.sections[this.activeSectionTitle].logoWhite;
      }, 500);
    },
    enterLogo: function(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          y: "105%"
        },
        {
          y: "0%",
          onComplete: done
        }
      );
    },
    leaveLogo: function(el, done) {
      TweenMax.to(el, 0.5, {
        y: "-105%",
        onComplete: done
      });
    },
    routeTest: function() {
      if (this.$route.params.activeSection == undefined) {
        this.activeSection = 0;
      } else {
        this.activeSection = this.$route.params.activeSection;
        this.activeSectionTitle = this.$route.params.activeSection;
        this.activeSectionSubpage = true;
        setTimeout(() => {
          this.showChild = true;
        }, 300);
      }
    }
  },
  beforeMount() {
    // this.innerHeight();
  },
  mounted() {
    this.innerHeight();
    this.detectOrientation();
    this.detectMobileKeyboard();
    this.detectionMobile();
    this.scrollOffMobile();
  },
  watch: {
    activeSection: function() {
      var _this = this;
      _this.showChild = false;
    }
    // isScrolling: function() {
    //   if (this.isScrolling == false) {
    //     window.onscroll = function() {};
    //   } else {
    //     window.onscroll = function() {
    //       window.scrollTo(0, 0);
    //     };
    //   }
    // }
  },
  // destroyed() {},
  components: {
    SectionTitle,
    Component1,
    ComponentSocialMonster,
    ComponentCunaSportwear,
    ComponentBrilliantMind,
    ComponentMercedes,
    ComponentJanczaki,
    ComponentPizzaBox,
    ComponentNykart,
    ComponentMatthias,
    ComponentStreetwear,
    ComponentSocialMonsterNew,
    ComponentAbout,
    ComponentTeam,
    ComponentContact,
    Menu,
    FloatingSocials,
    FloatingText,
    FloatingContact,
    FloatingCaseStudy,
    HomePageSectionsNav,
    LoadingScreen
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue